<template>
	<dstr-commission-dashboard :isRummyOptionSelected="true" />
</template>

<script>
import DstrCommissionDashboard from "../CommissionDashboard/DstrCommissionDashboard";
export default {
	components: {
		"dstr-commission-dashboard": DstrCommissionDashboard
	}
};
</script>
